// Generic string utilities. Keep this module dependency-free.

/** Strips everything that isn't a digit (0-9). */
export function onlyDigits(value: string): string {
  return value.replace(/\D/g, "");
}

/** Lowercase, accents stripped and trimmed, so "sao" finds "São Paulo". */
export function normaliseSearchText(value: string): string {
  return value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim();
}
